import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const Ctx = createContext(null);

export const CustomerProvider = ({ children }) => {
  const [customer, setCustomer] = useState(null);

  const reload = useCallback(() => api.get("/customer/me").then((r) => setCustomer(r.data)).catch(() => setCustomer(false)), []);
  useEffect(() => {
    reload();
  }, [reload]);

  const logged = !!customer;
  useEffect(() => {
    if (!logged) return undefined;
    const t = setInterval(reload, 20000);
    return () => clearInterval(t);
  }, [logged, reload]);

  const login = async (email, password) => setCustomer((await api.post("/customer/login", { email, password })).data);
  const register = async (body) => setCustomer((await api.post("/customer/register", body)).data);
  const logout = async () => {
    await api.post("/customer/logout").catch(() => {});
    setCustomer(false);
  };

  return <Ctx.Provider value={{ customer, setCustomer, reload, login, register, logout }}>{children}</Ctx.Provider>;
};

export const useCustomer = () => useContext(Ctx);
